import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { Badge } from "@opendate-app/setlist";

const blankPathStyle = {
  height: 20,
  width: 0,
  borderLeft: "1px solid var(--sl-border-primary)",
  marginTop: -3,
  marginBottom: -3,
};

export default memo((pathNode) => {
  const node = pathNode.data;

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={false}
        style={{visibility: "hidden"}}
      />
      {node.node_data?.label ? (
        <Badge size="sm" color="gray">{node.node_data.label}</Badge>
      ) : (
        <div style={blankPathStyle} />
      )}
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={false}
        style={{visibility: "hidden"}}
      />
    </>
  );
});
